import { invokeApiGateway } from '../../auth/api-client';
import type { Environment, TimelineEvent, ExecutionSummary, TraceNode, LogEntry } from '../types/debugger';

export async function fetchTimeline(env: Environment, advertiserId: string): Promise<TimelineEvent[]> {
  return invokeApiGateway(`/debug/advertiser/${encodeURIComponent(advertiserId)}/timeline?env=${env.toLowerCase()}`);
}

export async function fetchExecutionSummary(env: Environment, executionId: string): Promise<ExecutionSummary> {
  return invokeApiGateway(`/debug/execution/${encodeURIComponent(executionId)}?env=${env.toLowerCase()}`);
}

export async function fetchExecutionTrace(env: Environment, executionId: string): Promise<TraceNode> {
  return invokeApiGateway(`/debug/execution/${encodeURIComponent(executionId)}/trace?env=${env.toLowerCase()}`);
}

export async function fetchLogs(env: Environment, executionId: string): Promise<LogEntry[]> {
  return invokeApiGateway(`/debug/execution/${encodeURIComponent(executionId)}/logs?env=${env.toLowerCase()}`);
}
